import React from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';

import styles from './Logo.module.scss';
import usePresenter from './Logo.presenter';
import { LogoCombinedProps } from './types';

import LogoC1DefaultIcon from '../../../resources/legacyIcons/LogoC1Default.svg';
import LogoC1EntertainmentBlueIcon from '../../../resources/legacyIcons/LogoC1Blue.svg';
import LogoC1EntertainmentWhiteIcon from '../../../resources/legacyIcons/LogoC1Entertainment.svg';
import VividLogoIcon from '../../../resources/legacyIcons/VividLogo.svg';
import VividLogoWithColourIcon from '../../../resources/legacyIcons/VividLogoWithColour.svg';

const Logo: React.FC<LogoCombinedProps> = (props) => {
  const {
    asset,
    className,
    assetAlt,
    linkPath, // MANUAL OVERRIDE
  } = usePresenter(props);

  const variantName = `${asset}`;
  const currentStyle = styles[`logo${variantName}`];

  // MANNUAL OVERRIDE STARTS

  let logo = '';
  switch (variantName) {
    case 'LogoC1Default': {
      logo = LogoC1DefaultIcon;
      break;
    }
    case 'LogoC1EntertainmentBlue': {
      logo = LogoC1EntertainmentBlueIcon;
      break;
    }
    case 'LogoC1EntertainmentWhite': {
      logo = LogoC1EntertainmentWhiteIcon;
      break;
    }
    case 'VividLogo': {
      logo = VividLogoIcon;
      break;
    }
    case 'VividLogoWithColour': {
      logo = VividLogoWithColourIcon;
      break;
    }
  }

  if (linkPath) {
    return (
      <Link
        to={linkPath}>
        <img
          alt={assetAlt}
          src={logo}
          className={cx(currentStyle, className)} />
      </Link>
    );
  }

  return (
    <img
      alt={assetAlt}
      src={logo}
      className={cx(currentStyle, className)} />
  );
  // MANNUAL OVERRIDE ENDS
};

export default Logo;

